import { CloudCommand } from "../types.js";

export const getProfileData: CloudCommand = {
    action: "LINKEDIN_ACTIONS/GET_PROFILE_DATA",
    commandName: "prospects.getProfileData",
    buildPayload: (payload) => {
        const { memberId } = ((payload.payload as Record<string, unknown> | undefined) ?? {}) as { memberId?: string };
        return { memberId };
    },
};
